<template>
  <v-container fluid>
    <v-dialog
        v-model="editDialog"
        max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ editedItem.productName }}</span>
          <v-spacer></v-spacer>
          <v-btn @click="close" fab
                 dark
                 small>
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-if="editedItem.list && editedItem.list.length > 0" class="mt-4">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">
                      Номер заявки
                    </th>
                    <th class="text-left">
                      Дата создания
                    </th>
                    <th class="text-left">
                      Количество
                    </th>
                    <th class="text-left">
                      Заказчик
                    </th>
                    <th class="text-left">
                      Статус
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in editedItem.list"
                      :key="item.orderId"
                  >
                    <td>{{ item.orderId }}</td>
                    <td>{{ item.createdAt }}</td>
                    <td>{{ item.amount }}</td>
                    <td>{{ item.orderedByName }}</td>
                    <td>{{ item.statusEnum }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Панель фильтров -->
    <v-card class="mb-4">
      <v-card-title>
        Заявки
      </v-card-title>
    </v-card>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Фильтры
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-select v-model="filters.status" :items="statuses" item-value="key" item-text="title" label="Статус" outlined dense persistent-hint multiple />
            </v-col>
            <v-col cols="12" class="d-flex justify-start">
              <v-btn color="primary" @click="getData" class="mr-2">Применить</v-btn>
              <v-btn text @click="resetFilters">Сбросить</v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-card class="mt-6">
      <v-data-table
          :headers="headers"
          :items="data"
          :items-per-page="size"
          :server-items-length="totalElements"
          :options.sync="options"
          :multi-sort="false"
          class="elevation-1"
          :footer-props="{
            'items-per-page-text': 'Строк на странице:',
            'items-per-page-options': [5, 10, 20, 50]
          }"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="openDialog(item)" fab small color="teal">
            <v-icon color="white">
              mdi-view-list
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.statusText`]="{ item }">
          <v-chip v-if="item.status === 'PROCESS'" color="primary">
            {{ item.statusText }}
          </v-chip>
          <v-chip v-if="item.status === 'DECLINED'" color="red" text-color="white">
            {{ item.statusText }}
          </v-chip>
          <v-chip v-if="item.status === 'SUCCESS'" color="green" text-color="white">
            {{ item.statusText }}
          </v-chip>
          <v-chip v-if="item.status === 'RETURNED'">
            {{ item.statusText }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>


export default {
  name: 'PartnerOrderRequests',
  data() {
    return {
      statuses: [
        { title: 'В процессе', key: "PROCESS"},
        { title: 'Успешный', key: "SUCCESS"},
        { title: 'Отклоненный', key: "DECLINED"},
        { title: 'Возврат', key: "RETURNED"},
      ],
      filters: {
        status: []
      },
      editedItem: {
        productId: null,
        list: []
      },
      editDialog: false,
      data: [],
      size: 10,
      headers: [
        { text: 'Id', value: 'productId' },
        { text: 'Наименование', value: 'productName' },
        { text: 'Количество', value: 'amount' },
        { text: 'Действия', value: 'actions' },
      ],
      totalElements: 0,
      options: {},
    }
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    openDialog (item) {
      this.editedItem = item
      this.editDialog = true
    },
    close () {
      this.editDialog = false
      this.editedItem = {
        productId: null,
      }
    },
    resetFilters() {
      this.filters = {
        status: []
      }
      this.getData()
    },
    async getData () {
      try {
        const sortBy = this.options.sortBy && this.options.sortBy.length > 0 ? this.options.sortBy[0] : ''
        const ascOrDesc = sortBy ? this.options.sortDesc.length > 0 ? (this.options.sortDesc[0] ? 'desc' : 'asc') : '' : ''
        const data = {
          size: this.options['itemsPerPage'],
          page: this.options['page'] - 1,
        }
        if (this.filters.status.length > 0) {
          data.status = this.filters.status.join(',')
        }
        if (sortBy) {
          data.orderBy = sortBy
          data.ascOrDesc = ascOrDesc
        }
        const resp = await this.$store.dispatch('partnerOrders/getPartnerOrderRequests', data)
        this.data = resp
        this.totalElements = resp.totalElements
      } catch (e) {
        console.log(e)
      }
    },
  }
}
</script>
<style scoped>

</style>